import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MyAddressAllResponse,
  MyVehicleAllResponse,
} from '../../../../core/models/user.model';
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import {
  Blank,
  FeeType,
  MasterFee,
  Providers,
  TaxpayerInfo,
} from '../../../../core/models/information.model';
import { ApiService } from '../../../../core/services/api.service';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  AddressInfoPayload,
  CardAdvance,
  CardAdvanceDetail,
  CardAdvancePayload,
  CardAdvanceResponse,
  CPCardType,
} from '../../../../core/models/card.model';
import {
  FeeDetailsResponse,
  ClientIInfo,
} from '../../../../core/models/parking.model';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionInfo } from '../../../../core/models/finance.model';
import { InputComponent } from '../../../../tools/forms/input/input.component';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../core/services/api-form.service';
import { ModalProviderSiteComponent } from '../../modals/other/modal-provider-site/modal-provider-site.component';

@Component({
  selector: 'app-vehicle-card-future-details',
  imports: [
    CommonModule,
    FormsModule,
    InputComponent,
    ModalProviderSiteComponent
  ],
  templateUrl: './vehicle-card-future-details.component.html',
  styleUrl: './vehicle-card-future-details.component.css',
})
export class VehicleCardFutureDetailsComponent {
  // URL
  urlCardAdvanceId: string | null = null;
  subscriptionData: SubscriptionInfo[] = [];
  // CityParkingCardAdvance
  addressPayloadModel: AddressInfoPayload = {
    addressId: 0,
    type: 0,
    name: '',
    fullName: '',
    phone: '',
    email: '',
    address: '',
    subDistrict: '',
    district: '',
    province: '',
    zipCode: '',
    headquarters: false,
    branchNo: '',
    branch: '',
    taxId: '',
  };

  // CityParkingCardAdvance_Details
  cardAdvanceDetailsModel: CardAdvanceDetail[] = [];
  cardAdvanceDetailsCreateModel: CardAdvanceDetail = {
    name: '',
    type: 0,
    phone: '',
    plateNumber: '',
    province: '',
    brand: '',
    model: '',
    color: '',
    remark: '',
  };

  optionTypeCreateMember: { id: number; name: string }[] = [
    { id: 1, name: 'เบอร์โทร' },
    { id: 2, name: 'ทะเบียน' },
  ];

  // (Select)
  isOpenSelectTypeCreateMember: boolean = false;
  selectTypeCreateMember: { id: number; name: string } = { id: 0, name: '' };
  selectedCreateProvinceId: number | null = null;
  selectedCreateBrandVehicle: string = '';
  selectedCreateModelVehicle: string = '';
  // (Filter)
  filteredCreateModelVehicle: string[] = [];

  cardAdvancePayloadModel: CardAdvancePayload = {
    uid: 0,
    name: '',
    cardTypeId: 0,
    startDate: null,
    endDate: null,
    qty: 0,
    siteId: 0,
    feeId: 0,
    vehicleTypeId: 0,
    fee: 0,
    feeTypeId: 0,
    bankAccountId: 0,
    base64: '',
    remark: '',
    invoiceNo: '',
    fullTax: false,
    address: this.addressPayloadModel,
    cardAdvanceDetails: [],
    noServiceCharge: false,
    subscriptionId: 0,
    clientId: 0,
  };

  optionCardTypeID: CPCardType[] = [];
  optionFullFee: FeeDetailsResponse[] = [];
  optionClient: ClientIInfo[] = [];
  optionFeeTypeID: { value: number; label: string; status: boolean }[] = [];
  optionFeeID: MasterFee[] = [];
  optionAccountBank: { value: number; label: string }[] = [];
  base64Change: string = '';

  // File
  fileName: string | null = null;
  base64: string = '';

  // (Site ID)
  allProviders: Providers[] = [];
  siteId: number | null = null;
  siteName: string = '';
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  selectCarPlate: MyVehicleAllResponse[] = [];
  selectedCar: string | null = null;

  isRequestTax: boolean = false;
  isCheckboxFee: boolean = false;
  isShowBank: boolean = false;
  isLoading: boolean = false;
  // (Select)
  isOpenSelectCDCardType: boolean = false;
  isOpenSelectClientId: boolean = false;
  selectCDCardType: CPCardType = { id: 0, name: '', vehicleTypeId: 0 };
  selectClientId: ClientIInfo | null = null;
  isOpenSelectSiteId: boolean = false;
  isOpenSelectFeeTypeId: boolean = false;
  selectFeeTypeId: { value: number; label: string; status: boolean } = {
    value: 0,
    label: '',
    status: false,
  };
  isOpenSelectFeeId: boolean = false;
  selectFeeId: MasterFee = { id: 0, name: '' };
  selectSubscription: SubscriptionInfo | null = null;
  isOpenSelectAccountId: boolean = false;
  selectAccountId: { value: number; label: string } = { value: 0, label: '' };

  // Tax
  selectedTaxType: string = '1';
  filteredAddressList: MyAddressAllResponse[] = [];
  selectedAddress: MyAddressAllResponse | null = null;
  address_id: number = 0;
  addressListAll: MyAddressAllResponse[] = [];
  showSelectAddress: boolean = false;
  mainOffice: boolean = false;
  taxName: string = '';
  taxId: string = '';
  tax_phone: string = '';
  email: string = '';
  branchName: string = '';
  branchNo: string = '';
  address: string = '';
  provincess: any[] = [];
  selectedProvinceId: number | null = null;
  province_name: string | null = null;
  filteredAmphures: any[] = [];
  amphures: any[] = [];
  selectedAmphureId: number | null = null;
  amphure_name: string | null = null;
  filteredTambons: any[] = [];
  tambons: any[] = [];
  selectedTambonId: number | null = null;
  tambon_name: string | null = null;
  zipcode: string = '';

  // Modal
  showTaxModal: boolean = false;
  showCreateModal: boolean = false;
  showSelectProviderModal: boolean = false;

  // Disable
  isDisableInput: boolean = false;

  // Validate
  isTextValid: { where: string; result: boolean } = { where: '', result: true };
  isNumberValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };
  isSpecialValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };
  isTextNumberValid: { where: string; result: boolean } = {
    where: '',
    result: true,
  };

  constructor(
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private http: HttpClient,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.getCardType();
    this.getProviders();
    this.getFeeType(); // ดึงข้อมูล ประเภทรายรับชำระ
    this.getFeeId(); // ดึงข้อมูล ประเภทรายรับ

    setTimeout(() => {
      forkJoin({
        tambons: this.http.get<any[]>('json/thai_tambons.json'),
        amphures: this.http.get<any[]>('json/thai_amphures.json'),
        provinces: this.http.get<any[]>('json/thai_provinces.json'),
      }).subscribe({
        next: (response) => {
          this.tambons = response.tambons;
          this.amphures = response.amphures;
          this.provincess = response.provinces;

          // setTimeout(() => {
          //   this.getApiAddressAll();
          // }, 100);
        },
        error: (err) => {
          console.error('โหลดข้อมูลล้มเหลว', err);
        },
      });
    }, 1000);

    // อ่าน param id จาก route
    this.route.paramMap.subscribe((params) => {
      this.urlCardAdvanceId = params.get('id');
      //console.log('Current Url ID:', this.urlCardAdvanceId);

      if (this.urlCardAdvanceId) {
        this.isDisableInput = true;

        this.getCardAdvanceById(this.urlCardAdvanceId);
      }
    });
  }

  /* ------------------------------------------------- Function ------------------------------------------------ */
  /* ---- Style ----*/
  openTaxModal() {
    this.showTaxModal = true;
  }

  /* ---- Select ----*/
  onClickSelectCDCardType(selectOption: CPCardType) {
    this.isOpenSelectCDCardType = !this.isOpenSelectCDCardType;
    this.selectCDCardType = selectOption;

    console.log(
      'selectCDCardType : ',
      this.selectCDCardType,
      selectOption
    );

    setTimeout(() => {
      this.getSubscruption();
    }, 200);
  }

  onClickSelectClientId(selectOption: ClientIInfo) {
    this.isOpenSelectClientId = !this.isOpenSelectClientId;
    this.selectClientId = selectOption;
    this.cardAdvancePayloadModel.clientId = selectOption.id;
    console.log('selectClientId : ', this.selectClientId, selectOption);
  }

  onClickSelectFeeTypeId(selectOption: {
    value: number;
    label: string;
    status: boolean;
  }) {
    this.isOpenSelectFeeTypeId = !this.isOpenSelectFeeTypeId;
    this.selectFeeTypeId = selectOption;
    this.cardAdvancePayloadModel.feeTypeId = selectOption.value;
    this.isShowBank = selectOption?.status ?? false;
    this.selectFeeId = { id: 0, name: '' };
    //console.log('selectFeeTypeId : ', this.selectFeeTypeId, selectOption);
  }
  onClickSelectFeeId(selectOption: SubscriptionInfo) {
    //console.log('SubscriptionInfo', selectOption);
    this.isOpenSelectFeeId = !this.isOpenSelectFeeId;
    this.selectSubscription = selectOption;
    // //console.log('selectFeeId : ', this.selectFeeId, selectOption);
  }
  onClickSelectTypeCreateMember(selectOption: { id: number; name: string }) {
    this.isOpenSelectTypeCreateMember = !this.isOpenSelectTypeCreateMember;
    this.selectTypeCreateMember = selectOption;
    this.cardAdvanceDetailsCreateModel.type = selectOption.id;

    // Reset
    this.cardAdvanceDetailsCreateModel.phone = '';
    this.cardAdvanceDetailsCreateModel.plateNumber = '';
    this.cardAdvanceDetailsCreateModel.province = '';
    this.cardAdvanceDetailsCreateModel.brand = '';
    this.cardAdvanceDetailsCreateModel.model = '';
    this.cardAdvanceDetailsCreateModel.color = '';
    this.cardAdvanceDetailsCreateModel.remark = '';
    this.isTextValid = { where: '', result: true };
    this.isNumberValid = { where: '', result: true };

    // console.log(
    // 'selectTypeCreateMember : ',
    //   this.selectTypeCreateMember,
    //   selectOption
    // );
  }
  onClickSelectBrandVehicle() {
    this.cardAdvanceDetailsCreateModel.brand = this.selectedCreateBrandVehicle;

    //console.log('selectBrandVehicle : ', this.selectedCreateBrandVehicle);
  }
  onClickSelectModelVehicle() {
    this.cardAdvanceDetailsCreateModel.model = this.selectedCreateModelVehicle;

    //console.log('selectModelVehicle : ', this.selectedCreateModelVehicle);
  }
  onClickSelectAccountBank(selectOption: {
    value: number;
    label: string;
  }): void {
    this.isOpenSelectAccountId = !this.isOpenSelectAccountId;
    this.selectAccountId = selectOption;
    //console.log('selectAccountId : ', this.selectAccountId, selectOption);
  }
  // Modal
  closeTaxModal() {
    this.showTaxModal = false;
  }
  closeCreateModal() {
    this.showCreateModal = false;
  }
  openCreateModal() {
    this.showCreateModal = true;
  }

  /* ---- Card Advance ---- */
  onClickCheckBoxTax() {
    this.isRequestTax = !this.isRequestTax;
    this.cardAdvancePayloadModel.fullTax = this.isRequestTax;
  }
  selectProvider(provider: any) {
    this.showSelectProviderModal = false;
    this.siteId = provider.id;
    this.siteName = provider.name;

    //console.log('Site ID', this.siteId);
    setTimeout(() => {
      this.getFeeDetails(this.siteId ?? 0);
      this.getBank(this.siteId ?? 0);
      this.getClientInfo(this.siteId ?? 0);
      // this.carFilteredPlateList = [];
      // this.selectCarPlate = [];
      this.onClearFormSite();
    }, 300);
  }
  onClearFormSite() {
    this.selectCDCardType = { id: 0, name: '', vehicleTypeId: 0 };
    this.cardAdvancePayloadModel.startDate = null;
    this.cardAdvancePayloadModel.endDate = null;
    this.cardAdvancePayloadModel.qty = 0;
    this.selectClientId = { id: 0, name: '' };
    this.selectFeeTypeId = { value: 0, label: '', status: false };
    this.selectAccountId = { value: 0, label: '' };
    this.selectSubscription = null;

  }
  setCard() {
    this.CardOptions = this.optionFullFee
      .filter((fee) => fee.vehicle_name === this.selectedCar)
      .map((fee) => ({
        value: fee.id,
        label: `${fee.name} ( ${fee.fee} บาท )`,
        fig_day: fee.fig_day,
        vehicle_type_name: fee.vehicle_name,
        subscription_id: fee.subscription_id,
      }));
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    this.fileName = file.name;

    const reader = new FileReader();
    reader.onload = () => {
      this.base64 = reader.result as string;
      this.base64Change = this.base64; // ✅ ส่งค่า base64 กลับไป parent
    };
    reader.readAsDataURL(file);
  }

  clearFile(): void {
    this.fileName = null;
    this.base64 = '';
    this.base64Change = '';
  }
  onClickSaveCardAdvance() {
    // Set Value
    this.onSetValueCardAdvance();
    // Validate
    if (!this.onValidateCardAdvance()) return;

    // Sent API
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
      confirmButtonColor: '#ffec43ff',
      iconColor: '#f0b90bff',
    }).then((result) => {
      if (result.isConfirmed) {
        this.sentCardAdvanceInfo();
      }
    });

    // console.log(
    // 'cardAdvancePayloadModel',
    //   JSON.stringify(this.cardAdvancePayloadModel),
    //   this.cardAdvancePayloadModel
    // );
  }
  // Set Value
  onSetValueCardAdvance() {
    const user_id = this.cookieService.get('user_id');
    // set Value
    this.cardAdvancePayloadModel.uid = user_id ? parseInt(user_id) : 0;

    this.cardAdvancePayloadModel.cardTypeId = this.selectCDCardType.id;
    this.cardAdvancePayloadModel.fullTax = this.isRequestTax;
    this.cardAdvancePayloadModel.bankAccountId = this.selectAccountId.value;
    this.cardAdvancePayloadModel.vehicleTypeId = this.selectCDCardType.vehicleTypeId;
    this.cardAdvancePayloadModel.feeId = this.selectSubscription?.feeId || 0;
    this.cardAdvancePayloadModel.siteId = this.siteId ?? 0;
    this.cardAdvancePayloadModel.clientId = this.selectClientId?.id || 0;
    this.cardAdvancePayloadModel.subscriptionId =
      this.selectSubscription?.id || 0;
    this.cardAdvancePayloadModel.base64 = '' /*this.base64Change*/;
    this.cardAdvancePayloadModel.fee = this.cardAdvancePayloadModel.fee <= 0 ? 0 : this.cardAdvancePayloadModel.fee;

    // Tax Address
    this.addressPayloadModel.address = this.address ?? '';
    this.addressPayloadModel.subDistrict = this.tambon_name ?? '';
    this.addressPayloadModel.district = this.amphure_name ?? '';
    this.addressPayloadModel.province = this.province_name ?? '';
    this.addressPayloadModel.zipCode = this.zipcode ?? '';
    this.addressPayloadModel.headquarters = this.mainOffice;
    this.addressPayloadModel.name = this.taxName;
    this.addressPayloadModel.phone = this.tax_phone;
    this.addressPayloadModel.email = this.email;
    this.addressPayloadModel.branch = this.branchName;
    this.addressPayloadModel.branchNo = this.branchNo;

    this.cardAdvancePayloadModel!.address = this.addressPayloadModel;

    // Card Details
    this.cardAdvancePayloadModel!.cardAdvanceDetails =
      this.cardAdvanceDetailsModel;
  }
  onSetValueCardAdvanceResponse(response: CardAdvanceResponse) {
    this.cardAdvancePayloadModel!.name = response.name;
    this.cardAdvancePayloadModel!.startDate = response.startDate
      ? new Date(response.startDate)
      : null;
    this.cardAdvancePayloadModel!.endDate = response.endDate
      ? new Date(response.endDate)
      : null;
    this.siteId = response.siteId;
    this.siteName = response.siteName;
    if (this.siteId) {
      this.getFeeDetails(this.siteId);
      this.getBank(this.siteId);
      this.getClientInfo(this.siteId);
    }
    setTimeout(() => {
      this.cardAdvancePayloadModel.clientId = response.clientId
      this.selectClientId = this.optionClient.find(
        (e) => e.id == response.clientId
      ) ?? { id: 0, name: '' };
      this.selectFeeId = this.optionFeeID.find((e) => e.id == response.feeId) ?? {
        id: 0,
        name: '',
      };
      this.selectCDCardType = this.optionCardTypeID.find(
        (e) => e.id == response.cardTypeId
      ) ?? { id: 0, name: '', vehicleTypeId: 0 };
      this.isShowBank = this.selectFeeTypeId?.status ?? false;

      this.selectAccountId = this.optionAccountBank.find(
        (e) => e.value == response.bankId
      ) ?? { value: 0, label: '' };
      this.cardAdvancePayloadModel.feeTypeId = response.feeTypeId
      this.selectFeeTypeId = this.optionFeeTypeID.find(
        (e) => e.value == response.feeTypeId
      ) ?? { value: 0, label: '', status: false };

    }, 100)
    this.selectSubscription = { id: response.subscriptionId, name: response.subscriptionName, feeId: response.feeId };

    this.cardAdvancePayloadModel!.qty = response.qty;
    this.cardAdvancePayloadModel!.remark = response.remark;
    this.cardAdvancePayloadModel.invoiceNo = response.invoiceNo;
    this.cardAdvancePayloadModel.fee = response.fee;
    this.cardAdvancePayloadModel.fullTax = response.fullTax;
    this.cardAdvancePayloadModel.bankAccountId = response.bankId;
    this.cardAdvancePayloadModel.address = response.address;
    this.cardAdvancePayloadModel.cardAdvanceDetails =
      response.cardAdvanceDetails;
    this.cardAdvanceDetailsModel = response.cardAdvanceDetails;
    this.base64Change = response.pic ?? '';
    this.base64 = response.pic ?? '';
    this.fileName = response.pic ? 'มีไฟล์แนบ' : null;

    if (response.fullTax) {
      this.selectedProvinceId =
        this.provincess.find((e: any) => e.name === response.address.province)
          ?.id ?? null;
      this.province_name = response.address.province;
      this.selectedAmphureId =
        this.amphures.find((e: any) => e.name === response.address.district)
          ?.id ?? null;
      this.amphure_name = response.address.district;
      this.selectedTambonId =
        this.tambons.find((e: any) => e.name === response.address.subDistrict)
          ?.id ?? null;
      this.tambon_name = response.address.subDistrict;
      this.zipcode = response.address.zipCode;
      this.address = response.address.address;
      this.mainOffice = response.address.headquarters;
      this.taxName = response.address.name;
      this.tax_phone = response.address.phone;
      this.email = response.address.email;
      this.branchName = response.address.branch;
      this.branchNo = response.address.branchNo;
    }
    this.isRequestTax = response.fullTax;
    this.isCheckboxFee = true

    ////console.log('this.cardAdvancePayloadModel', this.cardAdvancePayloadModel , this.isCheckboxFee);
  }
  onClearCardAdvance() {
    this.cardAdvancePayloadModel = {
      uid: 0,
      name: '',
      cardTypeId: 0,
      startDate: null,
      endDate: null,
      qty: 0,
      siteId: 0,
      feeId: 0,
      vehicleTypeId: 0,
      fee: 0,
      feeTypeId: 0,
      bankAccountId: 0,
      base64: this.base64Change,
      remark: '',
      invoiceNo: '',
      fullTax: false,
      address: this.addressPayloadModel,
      cardAdvanceDetails: this.cardAdvanceDetailsModel,
      noServiceCharge: false,
      subscriptionId: 0,
      clientId: 0,
    };
    this.addressPayloadModel = {
      addressId: 0,
      type: 0,
      name: '',
      fullName: '',
      phone: '',
      email: '',
      address: '',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      headquarters: false,
      branchNo: '',
      branch: '',
      taxId: '',
    };
    this.cardAdvanceDetailsModel = [];
    this.isRequestTax = false;
    this.isCheckboxFee = false;
    this.isShowBank = false;
    this.isLoading = false;
    this.siteId = null;
    this.siteName = '';
    this.selectCDCardType = { id: 0, name: '', vehicleTypeId: 0 };
    this.selectFeeTypeId = { value: 0, label: '', status: false };
    this.selectFeeId = { id: 0, name: '' };
    this.selectAccountId = { value: 0, label: '' };
    this.fileName = null;
    this.base64 = '';
    this.base64Change = '';
  }
  // Validate
  onValidateCardAdvance() {
    if (this.cardAdvancePayloadModel.name == '') {
      this.toast.warn('กรุณาระบุชื่อ-นามสกุล');
      return false;
    } else if (this.cardAdvancePayloadModel.cardTypeId == 0) {
      this.toast.warn('กรุณาเลือกประเภทบัตรจอดรถ');
      return false;
    } else if (
      this.cardAdvancePayloadModel.startDate == null ||
      this.cardAdvancePayloadModel.endDate == null
    ) {
      this.toast.warn('กรุณาเลือกวันที่');
      return false;
    } else if (this.cardAdvancePayloadModel.qty <= 0) {
      this.toast.warn('กรุณาระบุจำนวนบัตร');
      return false;
    } else if (this.cardAdvancePayloadModel.clientId == 0) {
      this.toast.warn('กรุณาเลือกลูกค้า');
      return false;
    }
    else if (this.cardAdvancePayloadModel.siteId == 0) {
      this.toast.warn('กรุณาเลือกสาขา');
      return false;
    } else if (this.cardAdvancePayloadModel.vehicleTypeId == 0) {
      this.toast.warn('กรุณาเลือกประเภทรถ');
      return false;
    } else if (this.cardAdvancePayloadModel.feeTypeId == 0) {
      this.toast.warn('กรุณาเลือกประเภทรับชำระ');
      return false;
    } else if (this.cardAdvancePayloadModel.feeId == 0) {
      this.toast.warn('กรุณาเลือกประเภทรายรับ');
      return false;
    } else if (this.cardAdvancePayloadModel.feeTypeId == 3 && this.cardAdvancePayloadModel.bankAccountId == 0) {
      this.toast.warn('กรุณาเลือกธนาคาร');
      return false;
    }
    // else if ( this.cardAdvancePayloadModel.base64 == '') {
    //   this.toast.warn('กรุณาเลือกรูปภาพ');
    //   return false; } 
    else if (this.cardAdvancePayloadModel.invoiceNo == '') {
      this.toast.warn('กรุณาระบุเลขที่ใบแจ้งหนี้');
      return false;
    } else if (!this.isCheckboxFee && this.cardAdvancePayloadModel.fee <= 0) {
      this.toast.warn('กรุณาระบุค่าบัตร');
      return false;
    }
    else if (this.cardAdvancePayloadModel.fullTax) {
      if (this.cardAdvancePayloadModel.address.name == '') {
        this.toast.warn('กรุณาระบุชื่อผู้เสียภาษี');
        return false;
      } else if (this.cardAdvancePayloadModel.address.address == '') {
        this.toast.warn('กรุณาระบุที่อยู่');
        return false;
      } else if (this.cardAdvancePayloadModel.address.province == '') {
        this.toast.warn('กรุณาระบุจังหวัด');
        return false;
      } else if (this.cardAdvancePayloadModel.address.phone == '') {
        this.toast.warn('กรุณาระบุเบอร์โทรศัพท์');
        return false;
      } else if (this.cardAdvancePayloadModel.address.email == '') {
        this.toast.warn('กรุณาระบุอีเมล');
        return false;
      }
    }
    // else if (this.cardAdvancePayloadModel.cardAdvanceDetails.length == 0) {
    //   this.toast.warn('กรุณาเพิ่มรายละเอียดบัตรจอดรถ');
    //   return false;
    // }

    // Check Date
    if (
      this.cardAdvancePayloadModel.startDate != null ||
      this.cardAdvancePayloadModel.endDate != null
    ) {
      const start = new Date(this.cardAdvancePayloadModel.startDate);
      const end = new Date(this.cardAdvancePayloadModel.endDate);
      if (start > end) {
        this.toast.warn('วันที่สิ้นสุดต้องมากกว่าวันที่เริ่มต้น');
        return false;
      }
    }

    return true;
  }

  /* ---- Tax ----*/
  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type
    );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
      this.setValueAddress();
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
      this.setValueAddress();
    }
  }
  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;
      this.tax_phone = this.selectedAddress.phone;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
      }
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.address_id = 0;
      this.mainOffice = false;
      this.taxName = '';
      this.tax_phone = '';
      this.email = '';
      this.branchName = '';
      this.branchNo = '';
      this.taxId = '';
      this.address = '';
      this.zipcode = '';
      this.selectedProvinceId = null;
      this.province_name = '';
      this.filteredAmphures = [];
      this.selectedAmphureId = null;
      this.amphure_name = '';
      this.filteredTambons = [];
    }
  }
  getAddressByTaxId() {
    if (!this.taxId.trim()) {
      this.toast.warn('กรุณาระบุเลขผู้เสียภาษีก่อน');
    } else {
      this.isLoading = true;
      this.ApigetAddressByTaxId();
    }
  }

  onProvinceChange() {
    // //console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // //console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }
  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId)
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      // //console.log('✅ amphure_name:', this.amphure_name);
    }
  }
  onTambonsChange() {
    // //console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
          ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId)
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      // //console.log(this.tambon_name);
    }
  }
  summit() {
    this.showTaxModal = false;
  }

  /* ---- Card Advance details ---- */
  // ( Import Excel )
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const rows: any[] = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      // Map เป็น Model
      const details: CardAdvanceDetail[] = rows.map((row) => ({
        name: row['name'] || '',
        type: Number(row['type']) || 0,
        phone: row['phone'] || '',
        plateNumber: row['plateNumber'] || '',
        province: row['province'] || '',
        brand: row['brand'] || '',
        model: row['model'] || '',
        color: row['color'] || '',
        remark: row['remark'] || '',
      }));
      //this.cardAdvanceDetailsModel = this.cardAdvanceDetailsModel.concat(details);

      this.onInsertArrayCardAdvanceDetails(details);
    };

    reader.readAsArrayBuffer(file);
  }
  // ( Export excel )
  onExportToExcel() {
    const headersCardAdvandDetailsModel = [
      'name',
      'type',
      'phone',
      'plateNumber',
      'province',
      'brand',
      'model',
      'color',
      'remark',
    ];

    // ตัวอย่างข้อมูล
    const sampleData = [
      {
        name: 'ลูกค้า A',
        type: 1,
        phone: '0812345678',
        plateNumber: '',
        province: 'กรุงเทพฯ',
        brand: 'Honda',
        model: 'Civic',
        color: 'ดำ',
        remark: 'ตัวอย่างการทำไฟล์ Excel ข้อมูล type 1 เฉพาะ เบอร์โทร',
      },
      {
        name: 'ลูกค้า B',
        type: 2,
        phone: '',
        plateNumber: 'กข-1234',
        province: 'เชียงใหม่',
        brand: 'Toyota',
        model: 'Altis',
        color: 'ขาว',
        remark: 'ตัวอย่างการทำไฟล์ Excel  ข้อมูล type 2 เฉพาะ ทะเบียน ',
      },
    ];

    // รวม headers + sample data
    const worksheet = XLSX.utils.json_to_sheet(sampleData, {
      header: headersCardAdvandDetailsModel,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    XLSX.writeFile(workbook, 'CardAdvanceDetail_Template.xlsx');
  }
  // ( Province )
  onProvinceCreateChange() {
    // //console.log(this.selectedCreateProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedCreateProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedCreateProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedCreateProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedCreateProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // //console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedCreateProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }
  // ( Delete )
  onClickDeleteCardAdvanceDetails(index: number) {
    this.cardAdvanceDetailsModel.splice(index, 1);
    //this.toast.success('ลบข้อมูลเรียบร้อย');
  }
  onInsertArrayCardAdvanceDetails(
    data: CardAdvanceDetail | CardAdvanceDetail[]
  ) {
    // ตรวจสอบข้อมูลก่อน Push เข้า List
    if (data instanceof Array) {
      if (this.cardAdvanceDetailsModel.length + data.length <= 100) {
        this.cardAdvanceDetailsModel =
          this.cardAdvanceDetailsModel.concat(data);
        this.toast.success('Import ข้อมูลเรียบร้อย');
        return;
      }
    } else {
      if (this.cardAdvanceDetailsModel.length + 1 <= 100) {
        this.cardAdvanceDetailsModel.push(data);
        this.toast.success('บันทึกข้อมูลเรียบร้อย');
        return;
      }
    }
    this.toast.warn('จํานวนข้อมูลไม่เกิน 100 รายการ');
  }

  onClickSaveCardAdvanceDetails() {
    // set province
    this.cardAdvanceDetailsCreateModel.province = this.province_name ?? '';

    // ตรวจสอบข้อมูล
    if (!this.onValidateCardAdvanceDetails()) return;

    // เพิ่มข้อมูล
    this.onInsertArrayCardAdvanceDetails(this.cardAdvanceDetailsCreateModel);

    // Reset
    this.onClearCardAdvanceDetails();
    this.showCreateModal = false;

    // console.log(
    // 'cardAdvanceDetailsCreateModel',
    //   this.cardAdvanceDetailsCreateModel
    // );
  }
  onValidateCardAdvanceDetails() {
    if (this.cardAdvanceDetailsCreateModel.name == '') {
      this.toast.warn('กรุณาระบุชื่อ-นามสกุล');
      return false;
    } else if (this.cardAdvanceDetailsCreateModel.type == 0) {
      this.toast.warn('กรุณาเลือกประเภทสมาชิก');
      return false;
    } else if (
      this.cardAdvanceDetailsCreateModel.type == 1 &&
      this.cardAdvanceDetailsCreateModel.phone == ''
    ) {
      this.toast.warn('กรุณาระบุเบอร์โทรศัพท์');
      return false;
    } else if (
      this.cardAdvanceDetailsCreateModel.type == 2
    ) {
      if (this.cardAdvanceDetailsCreateModel.plateNumber == '') {
        this.toast.warn('กรุณาระบุทะเบียนรถ');
        return false;
      } else if (this.cardAdvanceDetailsCreateModel.province == '') {
        this.toast.warn('กรุณาระบุจังหวัด');
        return false;
      } else if (this.cardAdvanceDetailsCreateModel.brand == '') {
        this.toast.warn('กรุณาระบุยี่ห้อรถ');
        return false;
      } else if (this.cardAdvanceDetailsCreateModel.model == '') {
        this.toast.warn('กรุณาระบุรุ่นรถ');
        return false;
      } else if (this.cardAdvanceDetailsCreateModel.color == '') {
        this.toast.warn('กรุณาระบุสีรถ');
        return false;
      }
    }

    return true;
  }
  onClearCardAdvanceDetails() {
    // Reset
    this.cardAdvanceDetailsCreateModel = {
      name: '',
      type: 0,
      phone: '',
      plateNumber: '',
      province: '',
      brand: '',
      model: '',
      color: '',
      remark: '',
    };
    return;
  }

  /* ---- Validate ----*/
  onChangeValidateText(where: string, value: string) {
    const check = value.match(/[^a-zA-Zก-๙\s]/g);
    if (value == '' || check) {
      this.isTextValid = { where: where, result: false };
    } else {
      this.isTextValid = { where: where, result: true };
    }
    ////console.log("check text : " , value , check );
  }
  onChangeValidateNumber(where: string, value: string) {
    const check = value.match(/[^0-9]/g);
    if (value == '' || check) {
      this.isNumberValid = { where: where, result: false };
    } else {
      this.isNumberValid = { where: where, result: true };
    }
    //console.log('check number : ', value, check);
  }
  onChangeValidateTextNumber(where: string, value: string) {
    const check = value.match(/[^a-zA-Z0-9ก-๙\s]/g);
    if (value == '' || check) {
      this.isTextNumberValid = { where: where, result: false };
    } else {
      this.isTextNumberValid = { where: where, result: true };
    }
  }
  onChangeValidateSpecialChar(where: string, value: string) {
    const check = value.match(/[^a-zA-Z0-9ก-๙\s]/g);
    if (value == '' || check) {
      this.isSpecialValid = { where: where, result: false };
    } else {
      this.isSpecialValid = { where: where, result: true };
    }
    ////console.log("check text : " , value , check );
  }










  /* ------------------------------------------------- API ------------------------------------------------ */

  /* ---- Tax ---- */
  ApigetAddressByTaxId() {
    this.apiService.getAddressByTaxId(this.taxId.trim()).subscribe({
      next: (response: TaxpayerInfo) => {
        this.isLoading = false;
        //  //console.log(JSON.stringify(response).toString());
        if (!response || Object.keys(response).length === 0) {
          this.toast.error('ไม่พบข้อมูลผู้เสียภาษี');
          return;
        } else {
          this.taxName =
            response.company_branch_title_name + ' ' + response.company_name;
          this.address =
            response.company_address_no +
            ' หมู่ที่ ' +
            response.company_moo_number;
          if (response.company_branch_number === '0') {
            this.mainOffice = true;
          } else {
            this.mainOffice = false;
            this.branchName = response.company_branch_name;
          }
          const matchedProvince = this.provincess.find(
            (p) => p.name_th.trim() === response.company_province
          );
          if (matchedProvince) {
            this.selectedProvinceId = matchedProvince.id;
            this.province_name = response.company_province;
          } else {
            this.selectedProvinceId = null;
            this.province_name = '';
          }
          if (this.selectedProvinceId != null) {
            const provinceId = this.selectedProvinceId;
            this.filteredAmphures = this.amphures.filter(
              (a) => a.province_id === +provinceId
            );

            const selectedAmphureName = response.company_amphur;
            const matchedAmphure = this.filteredAmphures.find(
              (a) => a.name_th.trim() === selectedAmphureName
            );
            if (matchedAmphure) {
              this.selectedAmphureId = matchedAmphure.id;
              this.amphure_name = selectedAmphureName;
            } else {
              this.selectedAmphureId = null;
              this.amphure_name = '';
            }
          } else {
            this.filteredAmphures = [];
            this.selectedAmphureId = null;
            this.amphure_name = '';
          }
          if (this.selectedAmphureId != null) {
            const amphureId = this.selectedAmphureId;

            // กรองตำบลในอำเภอที่เลือก
            this.filteredTambons = this.tambons.filter(
              (a) => a.amphure_id === +amphureId
            );

            // ดึงชื่อจากที่อยู่
            const selectedTambonName = response.company_thambol;

            // หาใน list ว่าตรงกับตำบลไหน
            const matchedTambon = this.filteredTambons.find(
              (a) => a.name_th.trim() === selectedTambonName
            );

            if (matchedTambon) {
              this.selectedTambonId = matchedTambon.id;
              this.tambon_name = selectedTambonName;
              this.zipcode = response.company_postcode;
            } else {
              this.selectedTambonId = null;
              this.tambon_name = '';
              this.zipcode = '';
            }
          } else {
            this.filteredTambons = [];
            this.selectedTambonId = null;
            this.tambon_name = '';
          }
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  /* ---- Card Advance ---- */
  getCardType() {
    this.apiService.getCardAdvanceCardType().subscribe({
      next: (response: CPCardType[]) => {
        console.log('CPCardType', response);
        this.optionCardTypeID = response;
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getCardAdvanceById(card_advance_id: string) {
    this.apiService.getCardAdvanceById(card_advance_id).subscribe({
      next: (response: CardAdvanceResponse) => {
        //console.log('📦 getCardAdvanceById', response);
        // Set Value
        this.onSetValueCardAdvanceResponse(response);
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  getProviders() {
    this.apiFormService.getProviders().subscribe({
      next: (res) => {
        Swal.close();
        //console.log('📦 getProviders : ', res);
        this.allProviders = res;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        Swal.close();
      },
    });
  }

  getClientInfo(site_id: number) {
    this.apiService.GetClientIInfo(site_id).subscribe({
      next: (response: ClientIInfo[]) => {
        //console.log('📦 ClientIInfo', response);
        this.optionClient = response;
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  getFeeDetails(site_id: number) {
    this.apiService.getFeeDetails(site_id).subscribe({
      next: (response: FeeDetailsResponse[]) => {
        this.optionFullFee = response;
        this.CardOptions = []; // เริ่มต้นว่างก่อนรอเลือกประเภทรถ
        this.setCard();
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getBank(site_id: number) {
    this.apiFormService.getBank(site_id).subscribe({
      next: (response: Blank[]) => {
        //console.log('📦 getBank', response);
        this.optionAccountBank = response.map((bank) => ({
          value: bank.id,
          label: bank.bankName + ' (' + bank.accountNumber + ')',
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getFeeType() {
    this.apiFormService.getFeeType().subscribe({
      next: (response: FeeType[]) => {
        console.log('📦 getFeeType', response);
        this.optionFeeTypeID = response.map((feetype) => ({
          value: feetype.id,
          label: feetype.name,
          status: feetype.requestBank || false,
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }
  getSubscruption() {
    //console.log('Data : ' + this.siteId + ' / ' + this.selectCDCardType.id);
    this.apiService
      .GetSubscriptionInfo(this.siteId ?? 0, this.selectCDCardType.vehicleTypeId ?? 0)
      .subscribe({
        next: (response: SubscriptionInfo[]) => {
          console.log('SubscriptionInfo', response);
          this.subscriptionData = response;
        },
        error: (error) => {
          console.error('API error:', error);
        },
      });
  }
  getFeeId() {
    this.apiService.getFeeMaster().subscribe({
      next: (response: MasterFee[]) => {
        //console.log('📦 getFeeId', response);
        this.optionFeeID = response;
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  sentCardAdvanceInfo() {
    this.apiService
      .sentCardAdvanceInfo(this.cardAdvancePayloadModel)
      .subscribe({
        next: (response) => {
          console.log('📦 Response sent CardAdvance : ', response);
          if (response.code === '000') {
            this.toast.success(response.message);
            // Clear
            this.onClearCardAdvance();
          } else {
            this.toast.error(response.message);
          }
        },
        error: (error) => {
          console.error('API error:', error);
          this.toast.error('ส่งคำขอล้มเหลว');
        },
      });
  }
}
